module.exports = __webpack_public_path__ + "img/gq.8be10c94.svg";